/** Save a client-side blob as a file through a temporary `<a download>`.
 *  The object URL is revoked a moment later rather than synchronously —
 *  some browsers start the download only after the click handler returns. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/** `downloadBlob` for text (Markdown, JSON, …), UTF-8. */
export function downloadText(text: string, filename: string, mime = 'text/plain'): void {
  downloadBlob(new Blob([text], { type: `${mime};charset=utf-8` }), filename);
}

/** A string safe to use inside a file name: lower-case, `[a-z0-9._-]` only,
 *  runs of anything else collapsed to one dash, trimmed, ≤ 80 chars. */
export function fileSlug(s: string): string {
  const slug = s
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^[-.]+|[-.]+$/g, '');
  return slug.slice(0, 80) || 'file';
}
